// Responsive AVIF/WebP variants for hero/card images.
// Variants live at /assets/hero/{slug}-{480|800|1200}.{avif|webp}
// Generated with cwebp + avifenc (see scripts/optimize-hero.sh).

export const HERO_VARIANTS = {
  // Hero carousel (Instagram Stories)
  "/assets/cuadriciclo-rojo-practicas-aml-vigo.webp": "cuadriciclo-aml",
  "/assets/moto-kawasaki-z400-carnet-a2-vigo.webp": "moto-a2",
  "/assets/camion-carnet-c-vigo.webp": "camion-c",
  "/assets/furgoneta-remolque-carnet-be-vigo.webp": "furgoneta-be",
  "/assets/autobus-carnet-d-vigo.webp": "autobus-d",
  "/assets/permiso-por-puntos-conductor-vigo.webp": "puntos",

  // Permit landings
  "/assets/ciclomotor-yamaha-jog-permiso-am-vigo.webp": "am",
  "/assets/moto-yamaha-cygnus-125-carnet-a1-vigo.webp": "moto-a1",
  "/assets/moto-ducati-monster-permiso-a-vigo.webp": "moto-a",
  "/assets/cuadriciclo-ligero-carnet-aml-vigo.webp": "cuadriciclo-ligero",
  "/assets/coche-practicas-carnet-b-autoescuelas-faro-vigo.webp": "coche-b",
  "/assets/coche-remolque-carnet-b96-vigo.webp": "coche-b96",
  "/assets/camion-trailer-carnet-ce-vigo.webp": "camion-ce",
  "/assets/curso-cap-mercancias-viajeros-vigo.webp": "cap-mercancias",
  "/assets/curso-cap-vigo-autoescuelas-faro.webp": "cap-vigo",
  "/assets/moto-practicas-permiso-a2-vigo.webp": "moto-a2-practicas",
  "/assets/camion-practicas-permiso-c-vigo.webp": "camion-c-practicas",
  "/assets/curso-recuperacion-puntos-vigo-plaza-america.webp": "puntos-plaza",
  "/assets/acta-curso-recuperacion-puntos-dgt.webp": "acta-puntos",
  "/assets/limite-30-kmh-ciudad-vigo.webp": "limite-30",

  // Blog thumbnails
  "/assets/blog/cambios-dgt-octubre-2026.webp": "cambios-dgt",
  "/assets/blog/consejos-examen-practico.webp": "consejos-examen",
  "/assets/blog/guia-carnet-coche-vigo.webp": "guia-carnet-b",

  // Points calculator schedule images
  "/assets/horario-curso-recuperacion-puntos-vigo.webp": "horario-puntos",
  "/assets/horario-curso-recuperacion-carnet-vigo.webp": "horario-carnet",
};

export const heroSrcSet = (slug, ext) =>
  `/assets/hero/${slug}-480.${ext} 480w, /assets/hero/${slug}-800.${ext} 800w, /assets/hero/${slug}-1200.${ext} 1200w`;

// Default sizes hint suits half-viewport heroes on desktop and full-width on mobile.
// Override via the `sizes` prop when needed.
export const DEFAULT_HERO_SIZES = "(min-width: 1024px) 600px, (min-width: 640px) 100vw, 100vw";

export const getHeroSlug = (src) => (src ? HERO_VARIANTS[src] : null);
